import { CreateActionTask } from "../../types";

export const defaultValues = (data?: CreateActionTask) => {
  return {
    mr_group_id: data?.mr_group_id!,
    mr_brand_code: data?.mr_brand_code ?? "",
    mr_brand_name: data?.mr_brand_name ?? "",
    description: data?.description ?? ""
  };
};